export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./modal.vue?vue&type=template&id=940f03da"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/modals/modal.vue?vue&type=template&id=940f03da
// module id = Z87S
// module chunks = 0